import { Quote } from "lucide-react";
import { Tilt } from "./Tilt";
import { useSite } from "@/context/SiteContent";

export const Testimonials = () => {
  const { testimonials } = useSite();
  if (!testimonials?.items?.length) return null;
  return (
    <section className="testi-section" id="readers" data-testid="testimonials-section">
      <div className="container">
        <div className="testi-head reveal">
          <div className="eyebrow">{testimonials.eyebrow}</div>
          <h2>{testimonials.heading}</h2>
        </div>
        <div className="testi-grid">
          {testimonials.items.map((t, i) => (
            <Tilt max={6} className={`testi-card reveal${i === 1 ? " testi-card-accent" : ""}`} key={`${t.name}-${i}`}>
              <div data-testid={`testimonial-${i}`}>
                <Quote className="testi-mark" size={26} />
                <p className="testi-quote">{t.quote}</p>
                <div className="testi-who">
                  <span className="testi-avatar">{(t.name || "R").trim()[0]}</span>
                  <div><strong>{t.name}</strong><small>{t.role}</small></div>
                </div>
              </div>
            </Tilt>
          ))}
        </div>
      </div>
    </section>
  );
};
